<div class="modal-content w-100 h-100 d-flex flex-column justify-content-between">
  <apm-section-title title="{{ 448611 | apmTranslate }}" faIcon="triangle-exclamation"></apm-section-title>

  @if (availableSectionsResource.isLoading()) {
    <apm-inline-spinner></apm-inline-spinner>
  }

  <div class="d-flex flex-column gap-3">
    @if (showPartLoadData()) {
      <apm-slide-toggle [(isChecked)]="partLoadData" rightLabel="{{ 26705 | apmTranslate }}" />
    }
    @if (showIplv()) {
      <apm-slide-toggle [(isChecked)]="iplvGb" rightLabel="{{ 457036 | apmTranslate }}" />
    }
    @if (showAccop()) {
      <apm-slide-toggle [(isChecked)]="accop" rightLabel="{{ 457038 | apmTranslate }}" />
    }
  </div>

  <div class="row mt-4">
    <apm-button class="col-6" variant="secondary" (click)="cancel()">
      {{ RES.CANCEL | apmTranslate }}
    </apm-button>
    <apm-button class="col-6" (click)="save()">
      {{ RES.SAVE | apmTranslate }}
    </apm-button>
  </div>
</div>
